/**
 * @todo use {@link https://www.typescriptlang.org/tsconfig/#allowArbitraryExtensions} once upgraded
 * to TypeScript 5.0
 */
import { Context } from './types';
import defaultCompiled from './default.hbs';
import { TypeSafeTemplateDelegate } from '../../../Utility/Handlebars/types';

interface DefaultItem {
    animation: string | null;
    x: string | number;
    y: string | number;
    width: string | number;
    height: string | number;
    z: number | null;
}

interface DefaultTextboxes extends DefaultItem {
    text: string;
}

interface DefaultLegacyTextboxes extends DefaultItem {
    align: string;
    shadow: boolean;
    underline: string;
    italic: string;
    bold: string;
    lineheight: string;
    font: string;
    size: string;
    color: string;
    text: string;
}

interface DefaultShapes extends DefaultItem {
    color: string;
    shaperadius: string;
}

interface DefaultImages extends DefaultItem {
    url: string;
}

export interface DefaultContext {
    announcement: {
        id: string | number;
        background_color: string;
        bgimg: string | null;
        textboxes: Array<DefaultTextboxes | DefaultLegacyTextboxes>;
        shapes: Array<DefaultShapes>;
        images: Array<DefaultImages>;
    };
    widget: {
        config: {
            is_new_media_library: boolean;
        };
    };
}

export const defaultTemplate: TypeSafeTemplateDelegate<Context<DefaultContext>> = defaultCompiled;
